import { stringifyCookie } from './stringifyCookies';

import type * as cookie from 'cookie';

/**
 * Set-Cookie 헤더 문자열을 생성하여 쿠키를 만료시킵니다.
 * @description
 * - 기본 Path=/, HttpOnly=true와 과거 Expires를 설정합니다.
 * @example
 * // expireSetCookieString('KC_AUT')
 */
export const expireSetCookieString = (name: string, options?: cookie.SerializeOptions): string => {
  const { path, httpOnly, ...restOptions } = options ?? {};

  return stringifyCookie(name, '', {
    ...restOptions,
    path: path || '/',
    httpOnly: httpOnly ?? true,
    expires: new Date(0),
    maxAge: 0,
  });
};
